import actions from './actions';

const initialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const initialStateSingle = {
  data: null,
  loading: false,
  error: null,
};

const serviceCategoriesReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {

    case actions.SERVICE_CATEGORY_ADD_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case actions.SERVICE_CATEGORY_ADD_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case actions.SERVICE_CATEGORY_ADD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case actions.SERVICE_CATEGORIES_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.SERVICE_CATEGORIES_READ_SUCCESS:
      return {
        ...state,
        data, 
        error: false,
        loading: false,
      };
    case actions.SERVICE_CATEGORIES_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case actions.SERVICE_CATEGORY_UPDATE_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.SERVICE_CATEGORY_UPDATE_SUCCESS:
      return {
        ...state,
        data, 
        error: false,
        loading: false,
      };
    case actions.SERVICE_CATEGORY_UPDATE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const serviceCategoryReducer = (state = initialStateSingle, action) => {
  const { type, data, err } = action;
  switch (type) {
    case actions.SERVICE_CATEGORY_READ_BEGIN:
      return {
        ...initialStateSingle,
        loading: true,
      };

    case actions.SERVICE_CATEGORY_READ_SUCCESS:
      return {
        ...initialStateSingle,
        data,
        error: false,
        loading: false,
      };

    case actions.SERVICE_CATEGORY_READ_ERR:
      return {
        ...initialStateSingle,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export { serviceCategoriesReducer, serviceCategoryReducer };
